// modal.service.ts
import {ViewContainerRef , ComponentRef, Injectable, Type, ViewChild, AfterViewInit, OnInit, Inject } from '@angular/core';
import { MySynchDataStore } from '../data-stores/mysynch.datastore';
import { MysynchModalComponent } from '../modals/mysynch-modal/mysynch-modal.component';
import { OutofdateDataModalComponent } from '../modals/outofdate-data-modal/outofdate-data-modal.component';

import {_,moment} from '../../js/globals.js';
import { ModalDataService } from './modal-data.service';
import { NoMetaDataDateModalComponent } from '../modals/no-metadata-date-modal/no-metadata-date-modal.component';

interface ModalContainerRef {
    name: string;
    ref: ViewContainerRef;
}

@Injectable({
    providedIn: 'root',
})
export class ModalService {
    private modalContainerRefs: ModalContainerRef[] = [];
    private modalComponentRefs: ComponentRef<MysynchModalComponent>[] = [];
   
    private modalContainerRefTmpl: ModalContainerRef = {name:'',ref:null};

    private currentPageType:string = "";
    private currentActiveHerd:any = {};
    private modalOpening:boolean = false;

  // Map modalType to corresponding component factory
  private modalTypeComponentMap = {
    base: MysynchModalComponent,
    outOfDateDataModal: OutofdateDataModalComponent, // Add more entries for other custom modal types if needed
    noMetaDataDateModal: NoMetaDataDateModalComponent,
  };

  constructor(@Inject('MySynchFactory') protected MSF: any,
              @Inject('ApiFactory') protected api: any,
              @Inject(MySynchDataStore) protected mysynchDataStore: any,
              @Inject(ModalDataService) protected modalDataService: any,) {

                
                this.mysynchDataStore.currentPageType
                      .subscribe((pageType)=>{
                          this.currentPageType = _.cloneDeep(pageType);
                      });

                this.mysynchDataStore.currentActiveHerd
                .subscribe((herd)=>{
                    if(!_.isUndefined(herd)){
                      
                      if(!_.isEmpty(this.currentActiveHerd)){
                       this.checkDataCurrency(); 
                      }
                      
                      this.currentActiveHerd = _.cloneDeep(herd);
                      
                    }
                });

  }
  ngOnDestroy() {
    this.modalContainerRefs = [];
  }

  // function that adds to the this service's collection of modal containers
    addModalContainerRef(containerName:string,modalContainerViewRef: ViewContainerRef) {
        var modalContainerRef = _.cloneDeep(this.modalContainerRefTmpl) as ModalContainerRef;
        _.set(modalContainerRef,'name',containerName);
        _.set(modalContainerRef,'ref',modalContainerViewRef);
        this.modalContainerRefs.push(modalContainerRef);
    }
    // function that removes from the this service's collection of modal containers
    removeModalContainerRef(containerName:string) {
        this.modalContainerRefs = _.reject(this.modalContainerRefs, function(containerRef) { return _.isEqual(_.get(containerRef,'name'),containerName); });
    }
  
  openModal(
    containerName:string,
    modalType: string,
    configuration: any,
    customData: any,
    onCloseCallback: (error: any, data: any) => void,
  ): MysynchModalComponent | null {
    this.modalOpening  = true;
    let modalComponent: ComponentRef<MysynchModalComponent> | null = null;
    const modalComponentClass = this.modalTypeComponentMap[modalType];

    if (modalComponentClass) {
        const containerRef = _.find(this.modalContainerRefs, function(containerRef) { return _.isEqual(_.get(containerRef,'name'),containerName); });
        if (!_.isUndefined(containerRef)) {
            modalComponent = this.openCustomModal(modalComponentClass, configuration, customData, onCloseCallback, containerRef.ref);
        } else {
            console.error('Modal container ViewContainerRef not found');
           
        }
        this.modalOpening  = false;
    } else {
      console.error(`Modal type "${modalType}" not supported`);
      this.modalOpening  = false;
    }

    return modalComponent ? modalComponent.instance : null;
  }

  checkDataCurrency(){
    if(this.modalOpening === true){
      return;
    }
     this.modalOpening  = true;
    // check to see if there is already an out of date data modal open, before opening another one
    var outofdateDataModalOpen = _.find(this.modalComponentRefs, (modalComponentRef) => { 
          return _.isEqual(_.get(modalComponentRef,'instance.componentType'),'OutofdateDataModalComponent'); 
        });
    if(!_.isUndefined(outofdateDataModalOpen)){
      this.modalOpening  = false;
      return;
    }
    this.MSF.getActiveHerdWithWait().then((herd)=>{
      this.MSF.farmDataIsOutOfDate().then((farmDataIsOutOfDateResult)=>{

        var isOutOfDate = _.get(farmDataIsOutOfDateResult,'outOfDate',false);
        var metaLastEventDate = _.get(farmDataIsOutOfDateResult,'metaLastEventDate',null);

        var checkNoMetaDataDate = (_.isUndefined(metaLastEventDate) || _.isNull(metaLastEventDate)) && !_.includes(this.modalDataService.getNoMetaDataDateModalExcludeStates(),_.get(this.MSF,'state.current.name'));
        var checkOutOfDateData = (!_.isUndefined(metaLastEventDate) && !_.isNull(metaLastEventDate))  &&!_.includes(this.modalDataService.getOutofdateDataModalExcludeStates(),_.get(this.MSF,'state.current.name'));

        if(checkNoMetaDataDate){
            this.modalDataService.getNoMetaDataDateExpireDate(_.get(this.MSF,'cookies.user.PersonId'),_.get(herd,'herdId')).then((expirationDate)=>{
                var timeResetMomentExpirationDate = !_.isUndefined(expirationDate) && !_.isNull(expirationDate) ?  moment(expirationDate) :  moment({ year: 1, month: 0, day: 1 });
                var timeResetMomentNow = moment();
                if(  (
                          (_.isUndefined(expirationDate) || _.isNull(expirationDate))
                       || (    (!_.isUndefined(expirationDate) && !_.isNull(expirationDate))
                            && (timeResetMomentNow.isAfter(timeResetMomentExpirationDate))
                          )
                     )
                  && (!_.isEqual(this.currentPageType,"MultiFarm") || !_.includes(this.MSF.multiFarmStates,_.get(this.MSF,'state.current.name')))         
                ){
                  this.openModal('mysynch-modal-container','noMetaDataDateModal',{withBlur:true},null, (error,results)=>{
                    console.log("@@@@@ noMetaDataDateModal modal closed @@@@@@");
                    console.log(error);
                    console.log(results);
                  
                  });
                  // temp fix for angular digest cycle not refreshing after modal close
                  this.MSF.triggerAngularDigestCycleRefresh();
                 
              }else{
                this.modalOpening  = false;
              }

              
            },(error)=>{
              var currentHerdId = _.get(this.currentActiveHerd,'herdId');
              var currentPersonId = _.get(this.MSF,'cookies.user.PersonId');
              console.log("Failed to get No Meta Data Date Expiry Date for HerdId: "+currentHerdId+" and PersonId: "+currentPersonId);
              console.log(error);
              this.modalOpening  = false;
            });
         
        }

        if(checkOutOfDateData){
        
        this.modalDataService.getOutOfDateDataExpireDate(_.get(this.MSF,'cookies.user.PersonId'),_.get(herd,'herdId')).then(
          (expirationDate)=>{
            
              var timeResetMomentExpirationDate = !_.isUndefined(expirationDate) && !_.isNull(expirationDate) ?  moment(expirationDate) :  moment({ year: 1, month: 0, day: 1 });
              var timeResetMomentNow = moment();
          
              if(     isOutOfDate 
                   && (
                          (_.isUndefined(expirationDate) || _.isNull(expirationDate))
                       || (    
                               (!_.isUndefined(expirationDate) && !_.isNull(expirationDate))
                            && (timeResetMomentNow.isAfter(timeResetMomentExpirationDate))
                          )
                      )
                   && (!_.isEqual(this.currentPageType,"MultiFarm") || !_.includes(this.MSF.multiFarmStates,_.get(this.MSF,'state.current.name')))         
              ){
               
                    this.openModal('mysynch-modal-container','outOfDateDataModal',{withBlur:true},null, (error,results)=>{
                      console.log("@@@@@ outofdateData modal closed @@@@@@");
                      console.log(error);
                      console.log(results);
                    
                    });
                  // temp fix for angular digest cycle not refreshing after modal close
                  this.MSF.triggerAngularDigestCycleRefresh();
              }else{
                this.modalOpening  = false;
              }

          
          
          }
          ,(error)=>{
            var currentHerdId = _.get(this.currentActiveHerd,'herdId');
            var currentPersonId = _.get(this.MSF,'cookies.user.PersonId');
            console.log("Failed to get Out Of Date Data Expiry Date for HerdId: "+currentHerdId+" and PersonId: "+currentPersonId);
            console.log(error);
            this.modalOpening  = false;
          }
          );
        }

        // if we didn't need to check no meta data date expiry nor out of date data expiry (often because the user is on a multi farm or exlcuded page),
        // then we make sure to set modalOpening false
        if(!checkNoMetaDataDate && !checkOutOfDateData){
          this.modalOpening = false;
        }
          
       });
    });
  }

  private openCustomModal(
    modalComponentClass: Type<MysynchModalComponent>, // Pass the component class for the custom modal
    configuration: any,
    customData: any,
    onCloseCallback: (error: any, data: any) => void,
    modalContainerRef: ViewContainerRef,
  ): ComponentRef<MysynchModalComponent> {
    
    const modalComponentRef = modalContainerRef.createComponent(modalComponentClass);
    
    modalComponentRef.instance.configuration = configuration; // Pass configuration to the modal
    modalComponentRef.instance.customData = customData; // Pass custom data to the modal
    modalComponentRef.instance.closeModal.subscribe(({ error, data }) => {
      // When the modal emits the onClose event, call the callback function with error and data
      onCloseCallback(error, data);
      this.removeModal(modalComponentRef);
      modalContainerRef.clear(); // Clear the modal container
    });
    this.modalComponentRefs.push(modalComponentRef);
    return modalComponentRef;
  }

  private removeModal(modalComponent: ComponentRef<MysynchModalComponent>) {
    // Remove the modal component from the modalComponentRefs array
    const index = this.modalComponentRefs.indexOf(modalComponent);
    if (index !== -1) {
      this.modalComponentRefs.splice(index, 1);
    }
  }

  
 
       
        
    
        
        
    
  

}
